import { DataGridColSettings } from '@/components/DataGrid/utils';

export const relatedRecordsDataGridCols: DataGridColSettings[] = [
  {
    field: 'number',
    headerName: 'Record number',
    visible: true,
  },
  {
    field: 'location',
    headerName: 'Location',
    visible: true,
  },
  {
    field: 'dateAndTime',
    headerName: 'Date and Time',
    visible: true,
  },
  {
    field: 'involvement',
    headerName: 'Involvement',
    width: 180,
    visible: true,
  },
  {
    field: 'actions',
    headerName: '',
    width: 150,
    visible: true,
  },
];

export const wantedPersonRecordsDataGridCols: DataGridColSettings[] = [
  {
    field: 'number',
    headerName: 'Record number',
    visible: true,
  },
  {
    field: 'processType',
    headerName: 'Process Type',
    visible: true,
  },
  {
    field: 'disposition',
    headerName: 'Disposition',
    visible: true,
  },
  {
    field: 'dateIssued',
    headerName: 'Date Issued',
    width: 180,
    visible: true,
  },
  {
    field: 'actions',
    headerName: '',
    width: 150,
    visible: true,
  },
];

export const personCfsDataGridCols: DataGridColSettings[] = [
  { field: 'cfsId', headerName: 'CFS ID', visible: true },
  { field: 'location', headerName: 'Location', visible: true },
  { field: 'dateAndTime', headerName: 'Date and time', visible: true },
  { field: 'incidentCode', headerName: 'Incident Code', visible: true },
  {
    field: 'involvement',
    headerName: 'Involvement',
    width: 180,
    visible: true,
  },
  { field: 'actions', headerName: 'Actions', width: 80, visible: true },
];

export const personArrestDataGridCols: DataGridColSettings[] = [
  { field: 'number', headerName: 'Arrestee number', visible: true },
  { field: 'arrestId', headerName: 'Arrest ID', visible: true },
  { field: 'masterName', headerName: 'Arrestee name', visible: true },
  { field: 'arrestDate', headerName: 'Arrest date', visible: true },
  { field: 'arrestType', headerName: 'Arrest type', visible: true },
  { field: 'arrestStatus', headerName: 'Arrest status', visible: true },
  { field: 'dataWorksStatus', headerName: 'DataWorks Status', visible: true },
  { field: 'actions', headerName: 'Actions', width: 80, visible: true },
];

export const personCaseDataGridCols: DataGridColSettings[] = [
  { field: 'caseId', headerName: 'Case ID', visible: true },
  { field: 'location', headerName: 'Location', visible: true },
  { field: 'dateAndTime', headerName: 'Date and time', visible: true },
  { field: 'status', headerName: 'Status', visible: true },
  { field: 'disposition', headerName: 'Disposition', visible: true },
  {
    field: 'involvement',
    headerName: 'Involvement',
    width: 180,
    visible: true,
  },
  { field: 'actions', headerName: 'Actions', width: 80, visible: true },
];

export const personWarrantDataGridCols: DataGridColSettings[] = [
  { field: 'warrantId', headerName: 'Warrant ID', visible: true },
  { field: 'processType', headerName: 'Process type', visible: true },
  {
    field: 'involvement',
    headerName: 'Involvement',
    width: 180,
    visible: true,
  },
  { field: 'disposition', headerName: 'Disposition', visible: true },
  { field: 'dateIssued', headerName: 'Date issued', visible: true },
  { field: 'actions', headerName: 'Actions', width: 80, visible: true },
];

export const personTaskDataGridCols: DataGridColSettings[] = [
  { field: 'taskId', headerName: 'Tasks ID', visible: true },
  { field: 'taskType', headerName: 'Type', visible: true },
  { field: 'status', headerName: 'Status', visible: true },
  { field: 'dateAndTime', headerName: 'Date and time', visible: true },
  { field: 'actions', headerName: 'Actions', width: 80, visible: true },
];

export const personDirDataGridCols: DataGridColSettings[] = [
  { field: 'dirId', headerName: 'DIR ID', visible: true },
  { field: 'location', headerName: 'Location', visible: true },
  { field: 'dateAndTime', headerName: 'Date and time', visible: true },
  {
    field: 'involvement',
    headerName: 'Involvement',
    width: 180,
    visible: true,
  },
  { field: 'actions', headerName: 'Actions', width: 80, visible: true },
];
